import React, { useState } from "react";
import api from "../../../../api";
import { DropdownList } from "react-widgets";
import AutoCompleteInput from "../../../../components/form-group/auto-complete-input";
import DateInput from "../../../../components/form-group/date-input";
import { Customer } from "../../../../core";
interface Filters {
  eventType?: string;
  userId?: string;
  fromDate?: string;
  toDate?: string;
}

const ListFilter: React.FunctionComponent<{
  hideFilter: () => void;
  onFilter: (filter: Filters) => void;
  hideCRMFilter?: boolean;
}> = (props) => {
  const [filters, setFilters] = useState<Filters>();
  const [selectedSupportExecutive, setSelectedSupportExecutive] = useState<Customer | undefined>(undefined)

  const clearFilter = () => {
    setSelectedSupportExecutive(undefined)
    setFilters({});
    props.onFilter?.({});
    props.hideFilter();
  };

  const applyFilters = (key: string, value: string | Date) => {
    const newFilter: Filters = {
      ...filters,
      [key]: value,
    };

    setFilters(newFilter);
    props.onFilter?.(newFilter);
  };

  return (
    <div className="border-bottom p-3">
      <div className="form-group font-weight-semibold mb-2">
        <DropdownList
          data={[
            { label: "Create", value: "create" },
            { label: "Update", value: "update" },
            { label: "Delete", value: "delete" },
          ]}
          textField={"label"}
          valueField={"value"}
          placeholder={"Select Type"}
          onChange={(val) => applyFilters("eventType", val.value)}
        />
      </div>
      {!props?.hideCRMFilter && (
        <div className="form-group font-weight-semibold mb-2">
          <AutoCompleteInput
            defaultValue={selectedSupportExecutive}
            placeholder={"Support Executive"}
            hideBlocked={true}
            onChange={(val) =>{
               setSelectedSupportExecutive(val)
               applyFilters("userId", val?._id || "")
              }}
            apiUrl="api/user/crm-agents"
            valueField={"name"}
          />
        </div>
      )}
      <div className="form-group font-weight-semibold mb-2">
        <DateInput
          placeholder={"From Date"}
          onChange={(val: Date) => applyFilters("fromDate", val.toISOString())}
        />
      </div>
      <div className="form-group font-weight-semibold mb-2">
        <DateInput
          placeholder={"To Date"}
          onChange={(val: Date) => applyFilters("toDate", val.toISOString())}
          minDate={filters?.fromDate ? new Date(filters?.fromDate) : new Date()}
        />
      </div>
      <div className="pt-2 mb-2 text-right">
        <button
          type="reset"
          className="text-gray-400 btn p-0 font-normal mr-3 text-decoration-underline font-weight-semibold"
          onClick={clearFilter}
        >
          Clear Filter
        </button>
        <button
          type="button"
          className="text-primary font-weight-bold btn p-0 font-normal"
          onClick={props.hideFilter}
        >
          Hide Filter
        </button>
      </div>
    </div>
  );
};

export default ListFilter;
